'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithoutRef } from 'react';
import { useForm } from 'react-hook-form';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';
import { Form } from '@/shared/ui/form';
import { Icon } from '@/shared/ui/icon';
import './blog-newsletter-box.scss';

type FormValues = {
    email: string;
};

type Props = ComponentPropsWithoutRef<'div'>;
export const BlogNewsletterBox = ({ className, ...props }: Props) => {
    const t = useTranslations();
    const form = useForm<FormValues>({
        defaultValues: {
            email: '',
        },
    });

    const handleSubmit = (data: FormValues) => {
        alert(`Subscribed with email: ${data.email}`);
    };

    return (
        <div className={cn('blog-newsletter-box', className)} {...props}>
            <span data-testid="blog-newsletter-box-title">{t('BLOG.NEWSLETTER_BOX.TITLE')}</span>
            <p data-testid="blog-newsletter-box-description">{t('BLOG.NEWSLETTER_BOX.DESCRIPTION')}</p>
            <Form {...form} onSubmit={form.handleSubmit(handleSubmit)} noValidate>
                <Form.TextField
                    name="email"
                    label={t('BLOG.NEWSLETTER_BOX.LABEL')}
                    rules={{
                        required: true,
                    }}
                    right={
                        <Button
                            size="icon"
                            className="blog-newsletter-box__submit-button"
                            type="submit"
                            data-testid="blog-newsletter-box-submit"
                        >
                            <Icon name="chevron-right" />
                        </Button>
                    }
                />
            </Form>
        </div>
    );
};
